'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _isObject = require('is-object');

var _isObject2 = _interopRequireDefault(_isObject);

var _isFunction = require('is-function');

var _isFunction2 = _interopRequireDefault(_isFunction);

var _types = require('../types/');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var init = function init() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$type = _ref.type,
      type = _ref$type === undefined ? null : _ref$type,
      _ref$attribute = _ref.attribute,
      attribute = _ref$attribute === undefined ? null : _ref$attribute,
      _ref$display = _ref.display,
      display = _ref$display === undefined ? _types.any : _ref$display,
      _ref$input = _ref.input,
      input = _ref$input === undefined ? _types.any : _ref$input,
      _ref$api = _ref.api,
      api = _ref$api === undefined ? _types.any : _ref$api,
      _ref$label = _ref.label,
      label = _ref$label === undefined ? null : _ref$label,
      _ref$errorMessage = _ref.errorMessage,
      errorMessage = _ref$errorMessage === undefined ? null : _ref$errorMessage,
      additional = (0, _objectWithoutProperties3.default)(_ref, ['type', 'attribute', 'display', 'input', 'api', 'label', 'errorMessage']);

  if (type === null) throw new Error('please specify a attribute type');
  if (!(0, _isObject2.default)(label) || !label.default || !label.short) throw new Error('invalid label attribute');
  if (!attribute) throw new Error('please specify the attribute name');
  if (!(0, _isFunction2.default)(display)) throw new Error('display parameter should be a function but got ' + (typeof display === 'undefined' ? 'undefined' : (0, _typeof3.default)(display)));
  if (!(0, _isFunction2.default)(input)) throw new Error('input parameter should be a function but got ' + (typeof input === 'undefined' ? 'undefined' : (0, _typeof3.default)(input)));
  if (!(0, _isFunction2.default)(api)) throw new Error('api parameter should be a function but got ' + (typeof api === 'undefined' ? 'undefined' : (0, _typeof3.default)(api)));

  var attributeFn = function attributeFn(firstInput) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return {
      type: type,
      label: label,
      attribute: attribute,
      additional: additional,
      errorMessage: errorMessage,
      reinit: function reinit(newInput) {
        for (var _len2 = arguments.length, newArgs = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          newArgs[_key2 - 1] = arguments[_key2];
        }

        var initArgs = !!newArgs.length ? newArgs : args;
        return init((0, _extends3.default)({
          type: type,
          attribute: attribute,
          display: display,
          input: input,
          api: api,
          label: label,
          errorMessage: errorMessage
        }, additional)).apply(undefined, [newInput !== undefined ? newInput : firstInput].concat(initArgs));
      },
      display: display.apply(undefined, [firstInput].concat(args)),
      api: api.apply(undefined, [firstInput].concat(args)),
      input: input.apply(undefined, [firstInput].concat(args)),
      value: function value() {
        return firstInput !== undefined ? firstInput : null;
      }
    };
  };

  attributeFn.type = type;
  attributeFn.label = label;
  attributeFn.attribute = attribute;
  attributeFn.errorMessage = errorMessage;
  attributeFn.additional = additional;
  return attributeFn;
}; // Default type


exports.default = init;